import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.css']
})
export class OtpVerificationComponent {
  constructor( public router:Router) {}
  verifyOTP() {
    this.router.navigate(["/reset-password"])
  }
}
